import React from 'react';

import { Button } from 'apps/auth/components/common/Button/Button';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';

const MarketingCommunicationsTermsModal = ({ content = {}, modalRef }) => {
    return (
        <ModalComponent hasBottomPanel onCloseIconClick={() => modalRef?.current?.close()}>
            {content.title && <HeaderPanel title={content.title} />}
            {content.text && <Row indent="adaptive-16-24">{<DangerouslyHtml dangerouslyHtml={content.text} />}</Row>}
            {content.continueButton && (
                <FixedBottomPanel isRightAligned>
                    <Button
                        type="button"
                        raised={true}
                        onClick={() => {
                            modalRef?.current?.close();
                        }}
                        caption={content?.continueButton}
                        dataTestId="marketing-terms-continue-button"
                    />
                </FixedBottomPanel>
            )}
        </ModalComponent>
    );
};

export default MarketingCommunicationsTermsModal;
